<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2023-05-11 16:45:31
 * @LastEditors: lau
 * @LastEditTime: 2023-05-19 09:15:24
-->
<!-- 更新账单开票状态 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody:{
    "openInvoiceBillInfoList":[{
        "billCode":"2023051114363066769660",
        "billType":"0",
        "parkCode":"2KKN6112",
        "invoiceValue":"0.01"
    }],
    "openInvoiceInfo":{
        "invoiceBillType":"0",
        "invoiceType":"0",
        "invoiceTitle":"艾克",
        "invoiceSerial":"",
        "invoiceAddr":"",
        "invoicePhone":"",
        "orderType":1,
        "userMobile":"134****5432",
        "bankName":"",
        "bankAccount":"",
        "remark":"dev-open",
        "email":"15419@qq.com"

    }
},
            responseCode: {
    "data": {},
    "message": "开票成功",
    "resultCode": 900,
    "status": 1
},
            infoData: {
                explain: "第三方接入系统同步用户缴费信息到智慧停车开放平台",
                t_url: this.commonUrls.test + "openInvoiceByPark",
                p_url: this.commonUrls.prod + "openInvoiceByPark",
                precondition: "查询车场支付账单后调用，平台存在的账单",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },                        
                        { info1: 'openInvoiceInfo', info2: '是', info3: 'JSONObject', info4: '开票信息' },
                        { info1: 'openInvoiceBillInfoList', info2: '是', info3: 'JSONObject', info4: '开票时账单信息' },

                    ]
                },{
                    titleName: 'openInvoiceInfo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'invoiceType', info2: '是', info3: 'String', info4: '抬头类型0个人1企业' },
                        { info1: 'invoiceTitle', info2: '是', info3: 'String', info4: '发票抬头' },
                        { info1: 'userMobile', info2: '否', info3: 'String', info4: '手机号码' },
                        { info1: 'email', info2: '是', info3: 'String', info4: '接收邮箱' },
                        { info1: 'orderType', info2: '是', info3: 'Integer', info4: '0:合并开票 1:单独开票' },
                        { info1: 'invoiceValue', info2: '是', info3: 'BigDecimal', info4: '开票金额' },
                        { info1: 'invoiceSerial', info2: '否', info3: 'String', info4: '纳税人识别号' },
                        { info1: 'invoiceAddr', info2: '否', info3: 'String', info4: '注册地址' },
                        { info1: 'invoicePhone', info2: '否', info3: 'String', info4: '注册手机' },
                        { info1: 'bankName', info2: '否', info3: 'String', info4: '开户银行' },
                        { info1: 'bankAccount', info2: '否', info3: 'String', info4: '银行账号' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'invoiceBillType', info2: '否', info3: 'String', info4: '0蓝票1红票' },
                    ]
                },{
                    titleName: 'openInvoiceBillInfoList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    { info1: 'invoiceValue', info2: '是', info3: 'String', info4: '发票金额' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '账单流水号' },
                        { info1: 'billType', info2: '是', info3: 'Integer', info4: '(发票项目)账单类型 2月票 0停车费 (请根据账单类型如实填写), 如：停车记录的支付账单填0,月票收费明细填2(仅支持开通和续费)' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                  ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/invoice/openInvoiceByPark.vue